import { render, staticRenderFns } from "./SuccessBanner.vue?vue&type=template&id=7b685b2e&"
import script from "./SuccessBanner.vue?vue&type=script&lang=js&"
export * from "./SuccessBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports